const THREE = require('three')
import raf from 'src/components/game/raf'
import {load, registerSize, loadingManager} from 'src/components/game/loader'
import {TimelineMax, TweenMax, Cubic} from 'gsap'
import {config as gameConfig} from 'src/components/game/config'
import _ from 'lodash'

// *****************************************************************
//
// WRAPPER
//
// *****************************************************************
export let mesh = new  THREE.Object3D()
export default mesh
mesh.name = 'dashboard-shoe'




// *****************************************************************
//
// TEXTURES
//
// *****************************************************************
export let data = {
  shoe: {
    url: require('assets/chargemeter/shoe.png'),
    size: 9652
  },
  glow: {
    url: require('assets/chargemeter/shoe-active.png'),
    size: 12872
  }
}
for (let key in data) {
  let _data = data[key]
  _data.active = false
  let url = _data.url
  registerSize(url, _data.size)
  load(url, new THREE.TextureLoader(loadingManager), (results)=> {
    _data.map = results[0]
    checkAllLoaded()
  })
}

export let loaded = false
const checkAllLoaded = function () {
  for (let key in data) {
    if (!data[key].map) return
  }

  loaded = true
  init()
}

// *****************************************************************
//
// INIT
//
// *****************************************************************
const init = function () {
  for (let key in data) {
    let _data = data[key]
    let material = new THREE.MeshBasicMaterial({
      map: _data.map,
      transparent: true,
      alphaTest: 0.1
    })
    let geometry = new THREE.PlaneBufferGeometry(80, 80)
    let plane = new THREE.Mesh(geometry, material)
    plane.name = `chargemeter-shoe-${key}`
    mesh.add(plane)

    _data.material = material
    _data.mesh = plane
  }
  data.shoe.material.opacity = 0
  data.glow.material.opacity = 0
}



// *****************************************************************
//
// Updates
//
// *****************************************************************

export let start = (seconds) => {
  // console.log(data)
  let tl = new TimelineMax()
  tl.to(data.shoe.material, seconds / 2, {opacity: 1, ease: Cubic.easeOut})
  tl.to(data.glow.material, seconds / 4, {opacity: 1, ease: Cubic.easeOut}, `-=${seconds / 4}`)
  tl.to(data.glow.material, seconds / 4, {opacity: 0, ease: Cubic.easeOut})
}

export let reset = (seconds) => {
  data.shoe.material.opacity = 0
  data.glow.material.opacity = 0
}


export let glow = function() {
  let glow = data.glow
  if (glow.active) return
  glow.active = true
  if (glow.tween) glow.tween.kill()
  glow.tween = TweenMax.to(glow.material, 0.7, {
    opacity: 1,
    ease: Cubic.easeOut
  })
}

export let unglow = function() {
  let glow = data.glow
  if (!glow.active) return
  glow.active = false
  glow.tween.kill()
  glow.tween = TweenMax.to(glow.material, 0.6, {
    opacity: 0,
    ease: Cubic.easeOut
  })
}

const update = _.throttle(()=> {

  if (!window.game.state.stage2) return false
  if (!loaded) return

  let charge = window.game.state.stage2.charge

  if (charge >= 1) {
    glow()
  } else {
    unglow()
  }
}, gameConfig.uiUpdateInterval)

// raf.on('tick', update)
setInterval(update, gameConfig.uiUpdateInterval)




// WEBPACK FOOTER //
// ./src/components/game/ui/dashboard/shoe.js